import BEMHelper from '@ynap/bem-helper'
import { RadioButtonWithPrice } from '@ynap/radio-button'
import PropTypes from 'prop-types'
import React, { Fragment } from 'react'

const bem = new BEMHelper('PaymentOptionsForm')

const PaymentOptionButton = ({ id, children, onClick }) => {
    return (
        <RadioButtonWithPrice
            key={id}
            name={id}
            onClick={onClick}
            label={
                <Fragment>
                    <div className={bem('cardInfo')} onClick={onClick}>
                        <span>{children}</span>
                    </div>
                </Fragment>
            }
            className={bem('savedCard')}
        />
    )
}

const propTypes = {
    canChangePayment: PropTypes.bool,
    canAddPayment: PropTypes.bool,
    onAddOptionClick: PropTypes.func,
    onChangeOptionClick: PropTypes.func,
    messages: PropTypes.shape({
        paymentOptionsForm: PropTypes.shape({
            changePayment: PropTypes.func,
            addPayment: PropTypes.func,
        }).isRequired,
    }),
}

function PaymentOptionsModifier(props) {
    const { canChangePayment, canAddPayment, onAddOptionClick, onChangeOptionClick, messages } = props

    if (!canAddPayment && !canChangePayment) {
        return null
    }

    if (canChangePayment) {
        return (
            <PaymentOptionButton id="changePayment" onClick={onChangeOptionClick}>
                {messages.paymentOptionsForm.changePayment()}
            </PaymentOptionButton>
        )
    }

    return (
        <PaymentOptionButton id="addPayment" onClick={onAddOptionClick}>
            {messages.paymentOptionsForm.addPayment()}
        </PaymentOptionButton>
    )
}

PaymentOptionsModifier.propTypes = propTypes

export default PaymentOptionsModifier
